<div class="modal-header">
  <h4 class="modal-title">Add/Edit Announcement</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  <myp-inline-loader [loading]="loading" height="200px" spinnerName="addEditAnnouncementLoader"></myp-inline-loader>
  @if (!loading) {
    <div>
      <myp-segmented-bar
        (selected)="preview = $event.id == 'preview' ? true : false"
        [options]="[
          {
            name: 'Edit',
            id: 'edit',
            selected: true,
          },
          {
            name: 'Preview',
            id: 'preview',
          },
        ]"
      ></myp-segmented-bar>
      @if (!preview) {
        <div class="form-group m-t-20">
          <label class="control-label" for="title">Title</label>
          <input type="text" name="title" id="title" [(ngModel)]="announcement.title" class="form-control" />
        </div>
        <div class="form-group m-t-20">
          <label class="control-label" for="string_id">String ID</label>
          <span class="text-muted t-12 d-block m-b-5">
            A unique identifier used to track which users have seen this announcement. Use lowercase with hyphens or underscores. Cannot be changed after creation.
          </span>
          <input type="text" name="string_id" id="string_id" [(ngModel)]="announcement.string_id" class="form-control" [disabled]="announcement.id" />
        </div>

        <!-- Content Type Selector -->
        <div class="form-group m-t-20">
          <label class="control-label">Content</label>
          <div class="d-flex m-b-10">
            <span class="radio-option" (click)="contentType = 'visual'" [class.selected]="contentType === 'visual'">
              @if (contentType === "visual") {
                <fa-icon icon="check-circle"></fa-icon>
              }
              Visual Editor
            </span>
            <span class="radio-option" (click)="contentType = 'html'" [class.selected]="contentType === 'html'">
              @if (contentType === "html") {
                <fa-icon icon="check-circle"></fa-icon>
              }
              HTML
            </span>
            <span class="radio-option" (click)="contentType = 'image'" [class.selected]="contentType === 'image'">
              @if (contentType === "image") {
                <fa-icon icon="check-circle"></fa-icon>
              }
              Image
            </span>
          </div>

          @if (contentType === "visual") {
            <fui-quill-editor
              [content]="announcement.enDescription"
              (contentChange)="announcement.enDescription = $event"
              placeholder="Write your announcement..."
              height="300px"
              [toolbarOptions]="[['bold', 'italic', 'underline', 'strike'], [{ header: [1, 2, 3, false] }], [{ list: 'ordered' }, { list: 'bullet' }], ['link'], ['clean']]"
            ></fui-quill-editor>
          }
          @if (contentType === "html") {
            <span class="text-muted t-12 d-block m-b-5">Paste or write raw HTML below.</span>
            <textarea name="description" id="description" style="height: 300px" [(ngModel)]="announcement.enDescription" class="form-control"></textarea>
          }
          @if (contentType === "image") {
            <span class="text-muted t-12 d-block m-b-5">Upload an image that will be the entire announcement content.</span>
            @if (displayImage || imageUrl) {
              <div class="m-b-10">
                <img [src]="displayImage || imageUrl" style="max-width: 100%; max-height: 300px; border-radius: 8px" />
                @if (imageUploadProgress) {
                  <div class="progress m-t-10" style="height: 6px">
                    <div class="progress-bar" [style.width.%]="imageUploadProgress"></div>
                  </div>
                }
                @if (!imageUploadProgress) {
                  <button class="btn btn-secondary btn-sm m-t-5" (click)="removeImage()">Remove Image</button>
                }
              </div>
            }
            @if (!displayImage && !imageUrl) {
              <div ng2FileDrop [uploader]="imageUploader" class="file-drop-zone p-20 text-center border-radius10" style="border: 2px dashed var(--border-color)">
                <span>Drag image here or</span>
                <label class="btn btn-secondary btn-sm m-l-5">
                  Browse
                  <input type="file" ng2FileSelect [uploader]="imageUploader" accept="image/*" style="display: none" />
                </label>
              </div>
            }
            <div class="m-t-10">
              <label class="control-label" for="image_link">Link (optional)</label>
              <span class="text-muted t-12 d-block m-b-5">Users will be directed to this URL when they click the image.</span>
              <input type="url" name="image_link" id="image_link" [(ngModel)]="imageLink" class="form-control" placeholder="https://..." />
            </div>
          }
        </div>

        <div class="form-group m-t-20">
          <label class="control-label" for="external_link">Date &amp; Time</label>
          <span class="text-muted t-12 d-block m-b-5">Choosing a date in the past will turn this announcement on immediately for everybody.</span>
          <div class="form-control pointer" mode="button" name="release_date" id="release_date" (click)="showDatePicker()">
            @if (dateDisplay) {
              {{ dateDisplay }}
              <span class="text-muted m-l-5">({{ dateTimezone }})</span>
            } @else {
              {{ "newdash.choose_date" | translate }}
            }
          </div>
          @if (date) {
            <div class="d-flex m-t-10">
              <span class="radio-option" (click)="timezoneMode = 'local'" [class.selected]="timezoneMode === 'local'">
                @if (timezoneMode === "local") {
                  <fa-icon icon="check-circle"></fa-icon>
                }
                Show at this time in each user's timezone
              </span>
              <span class="radio-option" (click)="timezoneMode = 'fixed'" [class.selected]="timezoneMode === 'fixed'">
                @if (timezoneMode === "fixed") {
                  <fa-icon icon="check-circle"></fa-icon>
                }
                Show at the same moment everywhere
              </span>
            </div>
            <span class="text-muted t-12 d-block m-t-5">
              @if (timezoneMode === "local") {
                The announcement will appear at the selected time in each user's local timezone (e.g. 9am in New York AND 9am in Los Angeles).
              } @else {
                The announcement will appear at the exact same moment for all users worldwide, based on the selected timezone. For example if you set it to 9am America/New_York, it will appear at 9am in New York and 6am in Los Angeles.
              }
            </span>
          }
        </div>

        <div class="form-group m-t-20">
          <label class="control-label">End Date (optional{{ announcement.show_for_new_signups ? ' — required when "Show for new signups" is enabled' : '' }})</label>
          <span class="text-muted t-12 d-block m-b-5">If set, the announcement will stop showing after this date.</span>
          <div class="d-flex align-items-center">
            <div class="form-control pointer" style="flex: 1" (click)="showEndDatePicker()">
              @if (endDateDisplay) {
                {{ endDateDisplay }}
                <span class="text-muted m-l-5">({{ dateTimezone }})</span>
              } @else {
                Choose end date...
              }
            </div>
            @if (endDate) {
              <button class="btn btn-secondary btn-sm m-l-10" (click)="removeEndDate()">Clear</button>
            }
          </div>
        </div>

        <!-- Product Filter -->
        <div class="form-group m-t-20">
          <label class="control-label" for="product">Product Filter</label>
          <span class="text-muted t-12 d-block m-b-5">Search products below and select the ones you want to target. If you don't select any, this filter is ignored.</span>
          @if (selectedProductStringIds.length) {
            <div class="d-flex m-b-10">
              <span class="radio-option" (click)="productFilterMode = 'include'" [class.selected]="productFilterMode === 'include'">
                @if (productFilterMode === "include") {
                  <fa-icon icon="check-circle"></fa-icon>
                }
                Show to owners
              </span>
              <span class="radio-option" (click)="productFilterMode = 'exclude'" [class.selected]="productFilterMode === 'exclude'">
                @if (productFilterMode === "exclude") {
                  <fa-icon icon="check-circle"></fa-icon>
                }
                Hide from owners
              </span>
            </div>
          }
          <input class="form-control" name="product" [(ngModel)]="productQuery" placeholder="Search products..." />
          @if (searchingProducts) {
            <div class="d-flex align-items-center m-t-5">
              <fa-icon class="m-r-5" icon="spinner" [animation]="'spin'"></fa-icon>
              <span class="text-muted t-12">Searching...</span>
            </div>
          }
        </div>
        @if (productQuery && productResults && productResults.length) {
          <div class="product-results m-b-30 trans-bg border-radius10 p-10">
            @for (product of productResults; track product) {
              <myp-list-item [title]="product.title" [subData]="[product.DTYPE]" [includeChevron]="false" [showImage]="false">
                <div class="button-content">
                  <fa-icon icon="plus" placement="left" [ngbTooltip]="'Select Product'" (click)="selectProduct(product)" class="action green circle-icon-btn m-r-10"></fa-icon>
                </div>
              </myp-list-item>
            }
            <button class="btn btn-primary" (click)="this.productQuery = ''; this.productResults = []">Done</button>
          </div>
        }
        <div class="m-y-20">
          <div class="list-tags">
            @for (stringId of selectedProductStringIds; track stringId) {
              <span class="list-tag-item">
                {{ stringId }}
                <fa-icon icon="times-circle" (click)="removeProduct(stringId)"></fa-icon>
              </span>
            }
          </div>
        </div>

        <!-- Groups -->
        <div class="form-group row">
          <div class="col-12">
            <h4 class="section-header m-b-10">
              <myp-switch
                extraClasses="m-b-10"
                [active]="!userGroupsCollapsed"
                label="Only show to users in selected groups..."
                [labelToRight]="true"
                (toggle)="userGroupsCollapsed = !userGroupsCollapsed"
              ></myp-switch>
            </h4>
            @if (!userGroupsCollapsed) {
              <div class="m-b-20">Only users that have been assigned to a selected group will see this announcement.</div>
            }
          </div>
          @if (!userGroupsCollapsed && loadingGroups) {
            <div class="d-flex">
              <fa-icon class="m-r-10" icon="spinner" [animation]="'spin'"></fa-icon>
              <span>Loading Groups...</span>
            </div>
          }
          @if (groups?.length && !userGroupsCollapsed) {
            @for (group of groups; track group) {
              <div class="col-lg-4 col-md-6">
                <myp-switch
                  extraClasses="m-b-10"
                  [active]="groupMap[group.id].selected"
                  [label]="group.description"
                  [labelToRight]="true"
                  (toggle)="groupMap[group.id].selected = !groupMap[group.id].selected"
                ></myp-switch>
              </div>
            }
          }
        </div>

        <!-- Country Targeting -->
        <hr />
        <div class="form-group m-t-20">
          <label class="control-label">Country Targeting</label>
          <span class="text-muted t-12 d-block m-b-5">Target users by country. If no countries are selected, this announcement shows globally.</span>
          @if (selectedCountries.length) {
            <div class="d-flex m-b-10">
              <span class="radio-option" (click)="countryFilterMode = 'include'" [class.selected]="countryFilterMode === 'include'">
                @if (countryFilterMode === "include") {
                  <fa-icon icon="check-circle"></fa-icon>
                }
                Only show in these countries
              </span>
              <span class="radio-option" (click)="countryFilterMode = 'exclude'" [class.selected]="countryFilterMode === 'exclude'">
                @if (countryFilterMode === "exclude") {
                  <fa-icon icon="check-circle"></fa-icon>
                }
                Hide in these countries
              </span>
            </div>
          }
          <input class="form-control" name="country" [(ngModel)]="countryQuery" (ngModelChange)="filterCountries()" placeholder="Search countries..." />
          @if (filteredCountryList.length) {
            <div class="m-b-10 trans-bg border-radius10 p-10" style="max-height: 200px; overflow-y: auto">
              @for (country of filteredCountryList; track country.code) {
                <div class="pointer p-y-5 font-weight-bold" (click)="selectCountry(country)">{{ country.name }}</div>
              }
            </div>
          }
          <div class="list-tags m-t-10">
            @for (code of selectedCountries; track code) {
              <span class="list-tag-item">
                {{ countryNameMap[code] || code }}
                <fa-icon icon="times-circle" (click)="removeCountry(code)"></fa-icon>
              </span>
            }
          </div>
        </div>

        <hr />
        <!-- Audience -->
        <div class="form-group m-t-20">
          <label class="control-label" for="description">Audience</label>
          <span class="text-muted t-12">Choose where this will display.</span>
          <div class="d-flex">
            <span class="radio-option" (click)="audience.web = !audience.web" [class.selected]="audience.web">
              @if (audience.web) {
                <fa-icon icon="check-circle"></fa-icon>
              }
              Web
            </span>
            <span class="radio-option" (click)="audience.mobile = !audience.mobile" [class.selected]="audience.mobile">
              @if (audience.mobile) {
                <fa-icon icon="check-circle"></fa-icon>
              }
              Mobile
            </span>
          </div>
        </div>

        <!-- Subscription Filter -->
        <div class="form-group m-t-20">
          <label class="control-label">Subscription Filter</label>
          <span class="text-muted t-12 d-block m-b-5">Target users based on their {{ env.studioOnePlusBrandName }} subscription status.</span>
          <div class="d-flex">
            <span class="radio-option" (click)="subscriptionFilter = 'all'" [class.selected]="subscriptionFilter === 'all'">
              @if (subscriptionFilter === "all") {
                <fa-icon icon="check-circle"></fa-icon>
              }
              All Users
            </span>
            <span class="radio-option" (click)="subscriptionFilter = 'members_only'" [class.selected]="subscriptionFilter === 'members_only'">
              @if (subscriptionFilter === "members_only") {
                <fa-icon icon="check-circle"></fa-icon>
              }
              {{ env.studioOnePlusBrandName }} Only
            </span>
            <span class="radio-option" (click)="subscriptionFilter = 'non_members_only'" [class.selected]="subscriptionFilter === 'non_members_only'">
              @if (subscriptionFilter === "non_members_only") {
                <fa-icon icon="check-circle"></fa-icon>
              }
              Non-Members Only
            </span>
          </div>
        </div>

        <myp-switch
          extraClasses="m-b-10 m-t-20"
          [active]="announcement.show_for_new_signups"
          label="Show for new signups"
          [labelToRight]="true"
          (toggle)="announcement.show_for_new_signups = !announcement.show_for_new_signups"
        ></myp-switch>
        <span class="text-muted t-12 d-block m-b-10">By default, users who sign up after the start date won't see this announcement. Enable this for promos or content that should be visible to all users regardless of when they signed up.</span>
        <myp-switch extraClasses="m-b-10 m-t-20" [active]="announcement.dev" label="Only show in development." [labelToRight]="true" (toggle)="announcement.dev = !announcement.dev"></myp-switch>
      }
      @if (preview) {
        <div class="m-t-20">
          @if (announcement.title) {
            <fui-heading [text]="announcement.title" [level]="2"></fui-heading>
          }
          @if (date) {
            <span class="t-14 d-block m-b-10">{{ date | date }}</span>
          }
          @if (contentType === "image" && (displayImage || imageUrl)) {
            <img [src]="displayImage || imageUrl" style="max-width: 100%; border-radius: 8px" />
          }
          @if (contentType !== "image") {
            <div class="quill-content" [innerHTML]="previewDescription ? (previewDescription | safe: 'html') : 'No description entered yet...'"></div>
          }
        </div>
      }
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" [disabled]="loading" class="btn btn-primary" (click)="submit()">
    <span>Submit</span>
  </button>
  <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div>
